module.exports = __webpack_public_path__ + "static/media/MOTO-logo.0feaba55.png";